module.exports = __webpack_public_path__ + "img/gen2.54059fb1.jpg";